import { SimpleGrid } from '@mantine/core';
import usePersistUser from '@modules/core/hooks/usePersistUser';
import { AnimatedLoader } from '@components/AnimatedLoader';
import { t } from 'i18next';
import useGetBrokerProfile from '@modules/core/hooks/queries/useGetBrokerProfile';
import { useEffect } from 'react';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import { Flex, Text } from '@huspy/briks-web';
import { waitingRoomStyles } from '@modules/identity/presentation/pages/waiting-room/features/styles/index.css';
import PromotionCard from '@modules/identity/presentation/pages/waiting-room/components/PromotionCard';

const WaitingRoom = () => {
  const { user } = usePersistUser();
  const { data: brokerProfile } = useGetBrokerProfile(user?.id);

  useEffect(() => {
    if (!brokerProfile) return;
    trackAmplitudeEvent(USER_EVENTS.MISCELLANEOUS.BROKER_SIGNED_UP, { broker_id: brokerProfile.external_id });
  }, [brokerProfile]);

  if (user?.isGrantedAccessToMbPortal === undefined) {
    return (
      <Flex justify='center' align='center' h='75vh'>
        <AnimatedLoader dark />
      </Flex>
    );
  }

  return (
    <Flex direction='column' px='40'>
      <Flex
        direction='column'
        className={ waitingRoomStyles.HeaderCard }
      >
        <Flex direction='column' gap='2'>
          <Text fontWeight='semibold' size='5xl'>
            {t('waitingRoom.header.title')}
          </Text>
          <Text size='lg'>{t('waitingRoom.header.description.1')}</Text>
        </Flex>
      </Flex>
      <Text size='3xl' mb='4' fontWeight='semibold'>
        {t('waitingRoom.portal.title')}
      </Text>
      <SimpleGrid cols={ 3 } spacing='lg'>
        <PromotionCard
          header={ t('waitingRoom.portal.features.1.title') }
          text={ t('waitingRoom.portal.features.1.description') }
        />
        <PromotionCard
          header={ t('waitingRoom.portal.features.2.title') }
          text={ t('waitingRoom.portal.features.2.description') }
        />
        <PromotionCard
          header={ t('waitingRoom.portal.features.3.title') }
          text={ t('waitingRoom.portal.features.3.description') }
        />
      </SimpleGrid>
    </Flex>
  );
};

export default WaitingRoom;
